import css from './styles.module.scss';
import React from 'react';

type PatentProps = {
    patent?: string,
    isInBox?: boolean,
    isCenter?: boolean
}

export const Patent = ({patent, isInBox, isCenter}: PatentProps) => {
    return <>
        {patent && (isInBox ? <div className={`${css.patent_inbox}`} style={{position: isCenter ? 'static' : 'absolute'}}>{patent}</div> : <div className={css.patent}>
            <div className={`${css.patent__text}`}>{patent}</div>
        </div> )}
    </>
}